export default {
    data() {
        return {
            num: '',
        }
    },
    watch: {
        num(newValue) {
            let value = newValue;
            if (!newValue) {
                value = '';
            }
            this.setPolicyNumberByWatcher(value);
        },
    },
    methods: {
        setupNum() {

        },
        setPolicyNumberByWatcher(value) {
            this.$set(this.form, this.parkingLotField, value);
        },
        getClientPolicyValueByClient(client) {
            const field = this.policyField;
            if (!field) {
                return null;
            }
            return client[field];
        },
    },
    computed: {
        policyField() {
            const carrier = this.getCarrierObject;
            if (!carrier || !carrier.invoice_policy_field) {
                return 'policy_number';
            }
            return carrier.invoice_policy_field;
        },
        getPolicyName() {
            const carrier = this.getCarrierObject;
            if (!carrier) {
                return null;
            }
            if (!carrier.invoice_policy_name) {
                return 'Policy Number';
            }
            return carrier.invoice_policy_name;
        },
        getPolicyFieldType() {
            const carrier = this.getCarrierObject;
            
            if (!carrier) {
                return null;
            }
        },
        claimantIsCNAg() {
            const carrier = this.getCarrierObject

            if (carrier && carrier.parent_carrier_id === 9) {
                return true;
            }

            return false;
        },
        
        claimantIsCalpers() {
            const carrier = this.getCarrierObject
            if (carrier && carrier.name === "CalPERS") {
                return true;
            }

            return false;
        },

        getCarrierObject() {
            if (!this.client.carrier) {
                return null;
            }
            return this.client.carrier;
        },
        carrierName() {
            const carrier = this.getCarrierObject;
            if (!carrier.name) {
                return null;
            }
            return carrier.name;
        },
        isUnum() {
            let name = this.carrierName;
            if (!name) {
                return false;
            }
            name = name.toLowerCase();
            const needle = 'unum';
            return name.includes(needle);
        },
    },
    created() {
        this.setupNum();
    }
}
